import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';
import { GlobalStyles } from './styles/GlobalStyles';
import { CalendlyProvider } from './hooks/useCalendlyPopup';
// Old Home versions - moved to ./pages/old-home-pages/
// import { HomeV1 } from './pages/HomeV1';
// import { HomeV2 } from './pages/HomeV2';
// import { HomeV3 } from './pages/HomeV3';
// import { HomeV4 } from './pages/HomeV4';
// import { HomeV5 } from './pages/HomeV5';
// import { HomeV6 } from './pages/HomeV6';
// import { HomeV7 } from './pages/HomeV7';
import { HomeUltimate } from './pages/HomeUltimate';
import { QuickAnswer } from './pages/QuickAnswer';
import { DeepDive } from './pages/DeepDive';
import { ContactUltimate } from './pages/ContactUltimate';
import GetStarted from './pages/GetStarted';
import Analyze from './pages/Analyze';
import Compare from './pages/Compare';
import FindAdvisor from './pages/FindAdvisor';
import { Solutions } from './pages/Solutions';
import { Tools } from './pages/Tools';
import { About } from './pages/About';
import { Resources } from './pages/Resources';
import { DynoTester } from './pages/DynoTester';
import { Calculator } from './pages/Calculator';
import { AnnuityBasics } from './pages/AnnuityBasics';
import { AnnuityBacktester } from './pages/AnnuityBacktester';
import { BacktestAnnuities } from './pages/BacktestAnnuities';
import { RetirementCalculator } from './pages/RetirementCalculator';
import { Retirevana } from './pages/Retirevana';
// import { AboutUs } from './pages/AboutUs'; // Not used - using AboutUsV8 instead
import { Testimonials } from './pages/Testimonials';
import { InflationProtection } from './pages/InflationProtection';
import { FreeAnnuityAdvice } from './pages/FreeAnnuityAdvice';
import { EbookDownload } from './pages/EbookDownload';
import { APELanding } from './pages/APELanding';
import { AverillMethod } from './pages/AverillMethod';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { Terms } from './pages/Terms';
import { FamilyOfCompanies } from './pages/FamilyOfCompanies';
import { HowWeGetPaid } from './pages/HowWeGetPaid';
import { Contact } from './pages/Contact';
import { MediaPress } from './pages/MediaPress';
import Disclosures from './pages/Disclosures';
import { WhatWeOwn } from './pages/WhatWeOwn';
import ThankYou from './pages/ThankYou';
import AIBacktester from './pages/AIBacktester';
import Schedule from './pages/Schedule';
import QuintessentialQuestion from './pages/QuintessentialQuestion';
import { PermutationRequest } from './pages/PermutationRequest';
import { ScrollToTop } from './components/ScrollToTop';
import GrokCodeTest from './components/GrokCodeTest';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <CalendlyProvider>
        <Router>
          <ScrollToTop />
          <Routes>
          {/* Version switcher routes */}
          <Route path="/" element={<HomeUltimate />} />
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/start" element={<GetStarted />} />
          {/* Old version routes - deactivated
          <Route path="/v1" element={<HomeV1 />} />
          <Route path="/v2" element={<HomeV2 />} />
          <Route path="/v3" element={<HomeV3 />} />
          <Route path="/v4" element={<HomeV4 />} />
          <Route path="/v5" element={<HomeV5 />} />
          <Route path="/v6" element={<HomeV6 />} />
          <Route path="/v7" element={<HomeV7 />} />
          */}
          <Route path="/v8" element={<HomeUltimate />} />
          
          {/* Get Started Flow Pages */}
          <Route path="/analyze" element={<Analyze />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/find-advisor" element={<FindAdvisor />} />
          <Route path="/ai-backtester" element={<AIBacktester />} />
          <Route path="/thank-you" element={<ThankYou />} />
          
          {/* Main Navigation Pages */}
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/about" element={<About />} />
          <Route path="/resources" element={<Resources />} />
          
          {/* New V8 Pages */}
          <Route path="/dyno-tester" element={<DynoTester />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/annuity-backtester" element={<AnnuityBacktester />} />
          
          {/* Other pages with Layout wrapper */}
          <Route path="/annuity-basics" element={<AnnuityBasics />} />
          <Route path="/backtest-annuities" element={<BacktestAnnuities />} />
          <Route path="/retirement-calculator" element={<RetirementCalculator />} />
          <Route path="/retirevana" element={<Retirevana />} />
          <Route path="/consultation" element={<Contact />} />
          <Route path="/contact" element={<ContactUltimate />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/quick-answer" element={<QuickAnswer />} />
          <Route path="/deep-dive" element={<DeepDive />} />
          <Route path="/quintessential-question" element={<QuintessentialQuestion />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/inflation-protection" element={<InflationProtection />} />
          <Route path="/free-annuity-advice" element={<FreeAnnuityAdvice />} />
          <Route path="/free-ebook" element={<EbookDownload />} />
          <Route path="/ape" element={<APELanding />} />
          <Route path="/averill-method" element={<AverillMethod />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/disclosures" element={<Disclosures />} />
          <Route path="/our-family-companies" element={<FamilyOfCompanies />} />
          <Route path="/how-we-get-paid" element={<HowWeGetPaid />} />
          <Route path="/media-press" element={<MediaPress />} />
          <Route path="/what-we-own" element={<WhatWeOwn />} />
          <Route path="/permutation-request" element={<PermutationRequest />} />
          
          {/* Grok Code Fast 1 Test Route */}
          <Route path="/grok-test" element={<GrokCodeTest onClose={() => window.history.back()} />} />
        </Routes>
      </Router>
      </CalendlyProvider>
    </ThemeProvider>
  );
}

export default App;
